export default __webpack_public_path__ + "static/media/BG-LightBlue-0006.2ef381b5.png";